import React, { useEffect, useState } from 'react';
import './ValidationReferencesPriceNotOK.scss';
import IconItem from '../../../../../../components/Item/IconItem/IconItem';
import { faArrowLeft, faArrowRight, faCheck, faClose } from '@fortawesome/free-solid-svg-icons';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import CURRENCY from 'utils/constants/currency';
import { Trans, useTranslation } from 'react-i18next';
import { IRefOrder } from 'applications/automotor/views/espace-automotor-order/automotor-order.mode';
import Pagination from 'components/pagination/Pagination';
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { notify } from 'utils/marketplace';
import { formatNumberWithSpaces } from 'utils/utils';
import { useDispatch } from 'react-redux';
import { setCloseModal } from 'store/slices/proformaAutomotorModal.slice';

type Props = {
  setOpenModal: (e: boolean) => void;
  setStepModal: (e: string) => void;
  stepModalNext: string;
};

type IRowTable = {
  [key: string]: string | number | null | { totalPrice: string; index: number };
};
type IOption = {
  label: string;
  value: string;
  logo?: string;
};
type FormValues = {

  selectedSupplier: IOption | null;
};

const ValidationReferencesPriceNotOK: React.FC<Props> = (props) => {

  const { t } = useTranslation();
  const proformaFile = JSON.parse(localStorage.getItem('proformaFileInProgress') as string);
  const [data, setData] = useState<Array<IRefOrder>>([]);
  const user = JSON.parse(localStorage.getItem('userData')!);
  const [dataPagination, setDataPagination] = useState<Array<IRefOrder>>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(5);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [suppliers, setSuppliers] = useState<IOption[]>([]);
  const [selectedSupplier, setSelectedSupplier] = useState<string>('');
  const [isLoadingSuppliers, setIsLoadingSuppliers] = useState(false);
  const [disableBtn, setDisableBtn] = useState<boolean>(true);
  const [selectedRefs, setSelectedRefs] = useState<string[]>([]);

  const dispatch = useDispatch();


  const { setValue, control, } = useForm<FormValues>({
    defaultValues: {
      selectedSupplier: null,
    },
  });


  const handleClose = () => {
    props.setOpenModal(false);
    dispatch(setCloseModal(true));
  };

  useEffect(() => {
    if (props.stepModalNext === 'ValidationReferencesPriceNotOK') {

      setIsLoadingSuppliers(true);
      const referencePriceUpdate = proformaFile?.rows?.filter((row) => row.section === 'PRICE_UPDATE') || [];


      const references = referencePriceUpdate.reduce((rows: Array<IRowTable>, row, currentIndex) => {
        const qte = +(row.data[6] as number);

        const data = {
          reference: row.data[4],
          brand: 'brand1',
          file_price: row.info?.price_from_file ? `${formatNumberWithSpaces(Number(row.info?.price_from_file).toFixed(2))} ${CURRENCY[user!.currency]}` : (row.data[7] ? `${formatNumberWithSpaces(Number(row.data[7]).toFixed(2))} ${CURRENCY[user!.currency]}` : '-'),
          sell_price: row.info?.current_price ? `${formatNumberWithSpaces(Number(row.info?.current_price).toFixed(2))} ${CURRENCY[user!.currency]}` : '-',
          qte: qte,
          description: (row.info?.description ? row.info?.description : row.data[5]),
          total: {
            totalPrice: `${CURRENCY[user!.currency]}${row.info?.current_price * qte}`,
            index: currentIndex,
          },
          supplier_name: row.info?.supplier_name ? row.info?.supplier_name : '-',
          info: row.info,
          reference_internal: row.data[2],
          moq: row.info?.moq ? row.info?.moq : 1,
          uv: row.info?.uv ? row.info?.uv : 1,
          index: row.data[0],
        };

        rows.push(data);

        return rows;
      }, []);

      setData(references);

    }
  }, [props.stepModalNext]);

  useEffect(() => {
    setIsLoadingSuppliers(true);
    const suppliers: IOption[] = data.reduce((acc: IOption[], row) => {
      const supplierName = row.info?.supplier_name || '-';

      if (!acc.find((s) => s.value === supplierName)) {
        acc.push({
          label: supplierName,
          value: supplierName,
          logo: row.info?.supplier_logo,
        });
      }

      return acc;
    }, []);

    setSelectedRefs([]);
    setSuppliers(suppliers);
    setIsLoadingSuppliers(false);


  }, [data]);

  useEffect(() => {
    if (suppliers.length && selectedSupplier !== '') {
      let defaultSupplier;


      const filteredData = data.filter((item) => item.supplier_name === selectedSupplier);

      if (filteredData.length > 0) {
        defaultSupplier = suppliers.find((supplier) => supplier.label === selectedSupplier);
      } else {
        defaultSupplier = suppliers[0];
      }


      setSelectedSupplier(defaultSupplier?.value);

      setValue('selectedSupplier', defaultSupplier);

    }
  }, [suppliers]);

  useEffect(() => {
    if (data.length > 0) {
      let filteredData;

      if (selectedSupplier === '') {
        filteredData = data;
      } else {
        filteredData = data.filter((item) => item.supplier_name === selectedSupplier);
      }

      const total = filteredData.length;

      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;

      setTotalPages(Math.ceil(total / itemsPerPage));
      setDataPagination(filteredData.slice(startIndex, endIndex));
    }


  }, [data, currentPage, itemsPerPage, selectedSupplier]);

  const handlePageClick = (page: number) => {


    setCurrentPage(page);

  };


  const handleSelectAllPage = (checked: boolean) => {
    let filteredData;

    if (selectedSupplier === '') {
      filteredData = data;
    } else {
      filteredData = data.filter((item) => item.supplier_name === selectedSupplier);
    }

    const allIds = filteredData.map(r => `${r.reference}-${r.index}`);

    setSelectedRefs(checked ? allIds : []);
  };


  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target;

    setSelectedRefs(prev =>
      checked ? [...prev, value] : prev.filter(v => v !== value)
    );
  };

  useEffect(() => {


    if (selectedRefs.length > 0) {
      setDisableBtn(false);
    } else {
      setDisableBtn(true);
    }
  }, [selectedRefs]);


  const addPriceValid = () => {


    const selectedRows = data.filter((item) => selectedRefs?.includes(item.reference + '-' + item.index));


    const partsValid = proformaFile.partsWithReplacements;
    let rows = proformaFile.rows;


    for (const newItem of selectedRows) {

      const isRefExists = partsValid.some((item) => {
        return item.parts.some((part) => (part.short_name === newItem.reference));

      }
      );


      if (isRefExists) {
        notify(t('_item_already_exists') + ' Ref:' + newItem.reference, 'warning');

      }

      const existingIndex = partsValid.findIndex((item) => {
        return item.code_fou === newItem.info.codfou;
      });


      if (existingIndex !== -1) {

        const indexRow = partsValid[existingIndex].parts.length;

        const newRef = {

          is_manufacturer: newItem.info.is_manufacturer,
          supplier_id: newItem.info.supplier_id,
          current_price: newItem.info.current_price,
          description: newItem.info.description,
          supplier_name: newItem.info.supplier_name,
          codfou: newItem.info.codfou,
          reference: newItem.info.reference,
          price_from_file: newItem.info.price_from_file,
          itgr: newItem.info.itgr,
          supplier_logo: newItem.info.supplier_logo,
          quantity: newItem.qte,
          reference_internal: newItem.reference_internal,
          index: indexRow + 1,
          replace: null,
          name: newItem.info.supplier_name,
          source: 'man',
          reference_full: newItem.info.reference,
          supplier_cod_fou: newItem.info.codfou,
          manufacturer_cod_fou: newItem.info.codfou,
          short_name: newItem.info.reference,
          min_quantity: newItem.info.moq,
          uv: newItem.info.uv || 1,
          franco: newItem.info.franco,
          ind_equivalence: null,
          country_restriction: null,
          price: newItem.info.current_price,
          initial_price: null,
          discount: null,
          total: newItem.info.current_price * Number(newItem.qte),
          max_quantity: null,
          replace_status: false,
          weight: newItem.info.weight,
          volume: newItem.info.volume,
          country_name: newItem.info.country_name

        };

        partsValid[existingIndex].parts = Array.from(new Set([...partsValid[existingIndex].parts, newRef]));


      } else {
        const newRef = {
          code_fou: newItem.info.codfou,
          name: newItem.info.supplier_name,
          franco: newItem.info.franco,
          supplier_logo: newItem.info.supplier_logo,
          parts: [
            {

              is_manufacturer: newItem.info.is_manufacturer,
              supplier_id: newItem.info.supplier_id,
              current_price: newItem.info.current_price,
              description: newItem.info.description,
              supplier_name: newItem.info.supplier_name,
              codfou: newItem.info.codfou,
              reference: newItem.info.reference,
              price_from_file: newItem.info.price_from_file,
              itgr: newItem.info.itgr,
              supplier_logo: newItem.info.supplier_logo,
              quantity: newItem.qte,
              reference_internal: newItem.reference_internal,
              index: 0,
              replace: null,
              name: newItem.info.supplier_name,
              source: 'man',
              reference_full: newItem.info.reference,
              supplier_cod_fou: newItem.info.codfou,
              manufacturer_cod_fou: newItem.info.codfou,
              short_name: newItem.info.reference,
              min_quantity: newItem.info.moq,
              uv: newItem.info.uv || 1,
              franco: newItem.info.franco,
              ind_equivalence: null,
              country_restriction: null,
              price: newItem.info.current_price,
              initial_price: null,
              discount: null,
              total: newItem.info.current_price * Number(newItem.qte),
              max_quantity: null,
              replace_status: false,
              weight: newItem.info.weight,
              volume: newItem.info.volume,
              country_name: newItem.info.country_name

            }
          ]
        };

        partsValid.push(newRef);


      }

      rows = rows.filter((row) => !(row.data && row.data[4] === newItem.reference && row.data[0] === newItem.index));

    }

    const updatedProformaFile = {
      ...proformaFile,
      partsWithReplacements: partsValid,
      rows: rows
    };

    localStorage.setItem('proformaFileInProgress', JSON.stringify(updatedProformaFile));

    const dataFiltered = data.filter((item) => !selectedRefs?.includes(item.reference + '-' + item.index));

    setData(dataFiltered);


    if (currentPage === 1) {
      setCurrentPage(currentPage);
    }

    else if (dataFiltered.filter((item) => selectedRefs?.includes(item.reference + '-' + item.index)).length === 0) {
      setCurrentPage(1);
    }
    // Dacă pagina curentă e mai mare decât totalul de pagini (după ștergere), mergi pe ultima pagină validă
    else if (currentPage > Math.ceil(dataFiltered.length / itemsPerPage)) {
      setCurrentPage(Math.ceil(dataFiltered.length / itemsPerPage));
    } else {
      setCurrentPage(currentPage);
    }

    if (dataFiltered.length === 0) {

      props.setStepModal('ValidationReferencesMOQ');
    }
  };


  return (
    <div className="validation-custumer-order-price-modal" >
      <div className="close upload_order_info_price_not_ok_close">
        <IconItem icon={faClose} onClick={() => { handleClose(); }} />
      </div>


      <div className="validation-customer-modal-body">
        <div className="validation-customer-modal-row">
          <div className="validation-customer-modal-title">{t('_validation_of_prices')}</div>
          <div className="validation-customer-modal-subtitle">
            <Trans
              i18nKey="_validation_of_prices_message"
              components={{ bold: <br /> }}

            />
          </div>
        </div>
        <div className="validation-customer-modal-row">
          <div className="div-select-all">
            {suppliers.length > 1 && <div className="validation-customer-modal-select">
              {t('_supplier')}

              <Controller
                control={control}
                name="selectedSupplier"
                defaultValue={null}
                render={({ field: { onChange, value } }) => (
                  <Select
                    value={value}
                    className="validation-customer-modal-select-input"
                    onChange={(val) => {
                      onChange(val);
                      setSelectedSupplier(val?.value || '');
                      setCurrentPage(1);
                      setSelectedRefs([]); // Reset selectedRefs when changing supplier
                    }}
                    options={suppliers}
                    formatOptionLabel={(option) => (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {option.logo && <img src={option.logo ? option.logo : '/images/car-part-placeholder-big.png'} onError={({ currentTarget }) => { currentTarget.onerror = null; currentTarget.src = '/images/car-part-placeholder-big.png'; }} alt="Logo" height={18} />}
                        <span>{option.label}</span>
                      </div>
                    )}
                    placeholder={t('_select') + ' ' + t('_supplier')}
                    isClearable={false}
                    menuPlacement="top"
                    menuPosition="fixed"
                    isDisabled={suppliers.length === 1}
                    styles={{ menuPortal: base => ({ ...base, zIndex: 50 }) }}
                    isSearchable={false}
                    isLoading={isLoadingSuppliers}
                  />
                )}
              />


            </div>}
            <div className="checkbox" >

              <input
                type="checkbox"
                onChange={(e) =>
                  handleSelectAllPage(
                    e.target.checked
                  )
                }
                checked={selectedSupplier === '' ? data
                  .map(r => `${r.reference}-${r.index}`)
                  .every(id => selectedRefs.includes(id))
                  :
                  data.filter((item) => item.supplier_name === selectedSupplier)
                    .map(r => `${r.reference}-${r.index}`)
                    .every(id => selectedRefs.includes(id))

                }

              />{t('_select_items_across_all_pages')}
            </div>


          </div>
          <table className="validation-customer-modal-table">
            <thead>
              <tr >
                <th className="text-align-left"> {t('_reference')} / {t('_description')}</th>
                <th >{t('_brand')}</th>
                <th >{t('_quantity_order')}</th>
                <th >{t('_requested_unit_price')}</th>
                <th >{t('_current_unit_rate')}</th>
                <th >{t('_validate_AGP_rate')}</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                dataPagination.map((row) => (
                  <tr key={row.reference + row.index}>
                    <td className="text-align-left">{row.description ? `${row.reference ?? ''} / ${row.description}` : row.reference ?? ''}</td>
                    <td >
                      <div className="brand">
                        <div>
                          <img src={row.info?.supplier_logo ? row.info?.supplier_logo : '/images/car-part-placeholder-big.png'} onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = '/images/car-part-placeholder-big.png';
                          }} alt="Logo" height={16}
                          />
                        </div>

                        <div>{row.supplier_name || row.name}</div>
                        <div></div>
                      </div>
                    </td>
                    <td>{row.qte}</td>
                    <td>{row.file_price}</td>
                    <td>{row.sell_price}</td>
                    <td className="checkbox">
                      <input
                        type="checkbox"
                        id={row.reference + row.index}
                        value={row.reference + '-' + row.index}
                        checked={selectedRefs.includes(row.reference + '-' + row.index)}
                        onChange={handleCheckboxChange}
                      />
                    </td>
                  </tr>)))
                :
                <tr>
                  <td colSpan={6} className="no-data">{t('_no_data')}</td>
                </tr>
              }


            </tbody>
          </table>
          {totalPages > 1 && (
            <Pagination pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} hiddenParamPage iconsPrevious={faArrowLeft} iconsNext={faArrowRight} />
          )}
        </div>
        <div className="validation-customer-modal-row">
          <div className="validation-customer-modal-button">
            <DefaultButton className="validation-customer-modal-btn upload_order_info_price_add_to_estimation" text={t('_send_my_order_price_not_ok')} onClick={() => { props.setStepModal('ValidationReferencesPriceNotOKComment'); }} />
            <button className={`default-button validation-customer-modal-btn ${disableBtn ? 'disabled-btn' : ''} upload_order_info_price_next_step`} onClick={() => { addPriceValid(); }} ><FontAwesomeIcon icon={faCheck} />  {t('_valider_modifications')}</button>
            <DefaultButton className="validation-customer-modal-btn cancel upload_order_info_price_cancel" text={t('_cancel')} onClick={() => { handleClose(); }} />

          </div>

        </div>

      </div>
    </div>
  );

};

ValidationReferencesPriceNotOK.displayName = 'ValidationReferencesPriceNotOK';

export default ValidationReferencesPriceNotOK;


